"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _reactCsv = require("react-csv");

var _utils = _interopRequireDefault(require("../../../../../utils"));

var _RmName = _interopRequireDefault(require("../../../../../RmName.json"));

var header = [{
  label: "CL_code",
  key: "CL_code"
}, {
  label: "RM_code",
  key: "RM_code"
}, {
  label: "Reason",
  key: "Reason"
}, {
  label: "Attendance",
  key: "Attendance"
}, {
  label: "Today_Date",
  key: "Today_Date"
}, {
  label: "Date",
  key: "Date"
}];
var date = new Date();
var today = "".concat(date.getFullYear(), "-").concat(date.getMonth() + 1, "-").concat(date.getDate());
var time = "".concat(date.getHours(), ":").concat(date.getMinutes());

var TableData = function TableData(_ref) {
  var data = _ref.data;
  var csvRport = {
    filename: "\"Leaves Data\"+\" \"+".concat(today, "+\" \"+").concat(time),
    headers: header,
    data: data
  };

  var _useState = (0, _react.useState)(data),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      tableData = _useState2[0],
      setTableData = _useState2[1]; //     useEffect(async()=>{
  //         data.map((obj,index)=> { 
  //           if(obj.index===undefined) obj.index=index;
  //         })
  //       setTableData(data);
  // },[data]);


  (0, _react.useEffect)(function () {
    function fetchData() {
      return _fetchData.apply(this, arguments);
    }

    function _fetchData() {
      _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data.forEach(function (obj, index) {
                  if (obj.index === undefined) obj.index = index;
                });
                setTableData(data);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetchData.apply(this, arguments);
    }

    fetchData(); // eslint-disable-next-line 
  }, [data]);
  var columns = [{
    title: "".concat(_RmName.default.nameCode),
    dataIndex: 'RM_code',
    key: "RM_code",
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'RM_code');
    }
  }, {
    title: 'Start Date',
    dataIndex: 'Date',
    key: "Date",
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'Date');
    }
  }, {
    title: 'End Date',
    dataIndex: 'Today_Date',
    key: "Today_Date",
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'Today_Date');
    }
  }, {
    title: 'Reason',
    dataIndex: 'Reason',
    key: "Reason",
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'Reason');
    }
  }, {
    title: 'Leaves',
    dataIndex: 'Leaves',
    key: "Leaves",
    fixed: "left",
    sorter: function sorter(a, b) {
      return _utils.default.antdTableSorter(a, b, 'Leaves');
    }
  }];
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "History Of Leaves",
    extra: /*#__PURE__*/_react.default.createElement(_reactCsv.CSVLink, csvRport, /*#__PURE__*/_react.default.createElement(_icons.DownloadOutlined, {
      style: {
        'fontSize': 30
      }
    }))
  }, /*#__PURE__*/_react.default.createElement(_antd.Table, {
    columns: columns,
    dataSource: tableData,
    rowKey: "index"
  })));
};

var _default = TableData;
exports.default = _default;